import { useEffect } from 'react';

// Legacy redirect: kept for email links that still point to /sitter/payment.
// All sitters are sent to /app/sitter/payout (the real payout manager).
export const SitterPayment = (): JSX.Element => {
  useEffect(() => {
    window.location.href = '/app/sitter/payout';
  }, []);
  return <div />;
};
